import { useContext, useState } from 'react';
import * as R from 'ramda';

import AddFormsModal from '@atom/components/common/workOrderDetail/addFormsModal/AddFormsModal';
import WorkOrderContext from '@atom/components/workOrderDetail/WorkOrderContext';
import { Icon, IconButton } from '@atom/mui';
import {
  AddIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  LibraryBooksIcon,
} from '@atom/mui/icons';
import api from '@atom/utilities/api';
import {
  doesNotHaveRolePermissions,
  ROLE_SETS,
} from '@atom/utilities/authUtilities';
import { WORK_ORDERS_ENDPOINT } from '@atom/utilities/endpoints';

import FormTile from './FormTile';

import classes from './formSection.module.css';

const FormSection = () => {
  const { workOrderDetail, refetch, task, loading } =
    useContext(WorkOrderContext);

  const [open, setOpen] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(true);

  const handleAddForm = async (formTemplateIds: string[]) => {
    const endpoint = `${WORK_ORDERS_ENDPOINT}/${workOrderDetail.id}/tasks/${task.id}/formInstances`;

    await api.post(endpoint, { formTemplateIds });

    setOpen(false);
    refetch();
  };

  const isSectionEmpty = R.isEmpty(task.formInstanceIds);
  const totalCount = R.length(task.formInstanceIds);
  const icon = expanded ? ExpandLessIcon : ExpandMoreIcon;
  const isEditDisabled =
    workOrderDetail.isClosed || doesNotHaveRolePermissions(ROLE_SETS.INSPECTOR);

  return (
    <>
      <div className={classes.sectionContainer}>
        <Icon icon={LibraryBooksIcon} />
        <div className={classes.sectionTitle}>Forms</div>
        <div className={classes.totalCount}>{totalCount}</div>
        <div className={classes.buttonsContainer}>
          {expanded && (
            <IconButton
              onClick={() => setOpen(!isEditDisabled)}
              edge="end"
              tooltip="Add Forms"
              disabled={isEditDisabled}
            >
              <Icon icon={AddIcon} />
            </IconButton>
          )}
          <IconButton onClick={() => setExpanded(!expanded)} edge="end">
            <Icon icon={icon} />
          </IconButton>
        </div>
      </div>
      {expanded && (
        <div className={classes.tileList}>
          {isSectionEmpty ? (
            <div className={classes.emptySectionText}>Add Forms</div>
          ) : (
            <>
              {task.formInstanceIds.map(formInstanceId => (
                <FormTile
                  key={formInstanceId}
                  formInstanceId={formInstanceId}
                />
              ))}
            </>
          )}
        </div>
      )}
      <AddFormsModal
        schemaId={workOrderDetail?.inventoryAssetSchemaId}
        loading={loading}
        open={open}
        onClose={() => setOpen(false)}
        handleAddForm={handleAddForm}
      />
    </>
  );
};

export default FormSection;
